import {
    deleteRequesAssetsSimulation,
    deleteRequesProviderSimulation,
    getRequesAllDataInitSimulation,
    getRequesAllSimulationData,
    getRequestAllSimulation,
    postRequesAssetsSimulation,
    postRequesProviderSimulation,
    postRequestimulation,
    putRequesAssetsSimulation,
    putRequesProviderSimulation,
    putRequesSimulation,
} from "../../../config";
import { tasksConcluedForEntrys } from "../../../helpers/checkEntriesProject";
import {
    getTableAssetsSimulation,
    getTableEquivalencySimulation,
    getTableInfoSimulation,
    getTableProvidersSimulation,
    isEmptyObject,
} from "../../../helpers/simulationHelper";
import { trimSpaces } from "../../../helpers/textTransform";
import { typeForm } from "../../../types/forms";
import {
    formInitAssetsSimulation,
    formInitProviderSimulation,
    loadingsSimulation,
    modalsTypeSimulation,
} from "../../../types/initStore/initSimulation";
import { MessageType } from "../../../types/messageType";
import { statusProjectType } from "../../../types/statusProject";
import { MessageAnt } from "../ui/uiAction";
import {
    setAreasTeam,
    setAssetsTable,
    setErrorSimulation,
    setFormAssets,
    setFormEquivalecy,
    setFormProviders,
    setIsExistHrsEquivalency,
    setLoadingSimulation,
    setModals,
    setProjectData,
    setProjectId,
    setProvidersCalculationTable,
    setProvidersTable,
    setSelectTypeForm,
    setTableEquivalencyAssets,
    setTableEquivalencyProvider,
    setTableInfoGeneral,
} from "./simulation";

export const infoProjectGeneral = (clickuphrs, tableAssets, tableProvider) => {
    return async (dispatch, getState) => {
        const {
            project: { name, calculatedHours, status },
            tasks,
            tasksArea,
            extraResources,
            extraTime,
        } = clickuphrs;
        let tasksSelect = tasks;
        if (status === statusProjectType.concluid) {
            tasksSelect = tasksConcluedForEntrys(tasksArea);
        }
        const sumDevelopPlanning = calculatedHours.development.total + calculatedHours.planning;

        const { tableInfo, tableInfoHrs } = getTableInfoSimulation(
            tableAssets,
            tableProvider,
            {
                name,
                status,
                tasksSelect,
                extraResources,
                extraTime,
                budget: {
                    unity: calculatedHours.development.unity,
                    design: calculatedHours.development.design,
                    web: calculatedHours.development.web,
                    art3d: calculatedHours.development.modeling,
                    planning: calculatedHours.planning,
                },
            },
            { develop: calculatedHours.development.total, hrsTotal: sumDevelopPlanning, planning: calculatedHours.planning }
        );
        dispatch(setTableInfoGeneral({ tableInfo: tableInfo, tableInfoHrs: tableInfoHrs }));
    };
};

export const getAllSimulation = (projectId = 0) => {
    return async (dispatch, getState) => {
        const {
            simulation: { loadings },
        } = getState();

        dispatch(setLoadingSimulation({ ...loadings, tableLoading: true }));
        dispatch(setProjectId(projectId));
        if (!projectId) {
            dispatch(setErrorSimulation(true));
            dispatch(setLoadingSimulation(loadingsSimulation));
            MessageAnt(MessageType.error, "No se encontró proyecto en la ruta (project)");
            return;
        }
        const { status: stHrsEquivalency, payload: payloadHrsEquivalency } = await getRequestAllSimulation(projectId);
        if (stHrsEquivalency > 0) {
            dispatch(setErrorSimulation(true));
            dispatch(setLoadingSimulation(loadingsSimulation));
            MessageAnt(MessageType.error, "Error al obtener horas de equivalencia");
            return;
        }

        if (isEmptyObject(payloadHrsEquivalency.assets) && isEmptyObject(payloadHrsEquivalency.providers)) {
            dispatch(setLoadingSimulation(loadingsSimulation));
            return;
        }

        //* existe las horas, //* simulacion equivalencia
        const infoSimulationAssets = {
            assetMoneyMX: parseFloat(payloadHrsEquivalency.assets.hourMX["$numberDecimal"]),
            assetMoneyDLL: parseFloat(payloadHrsEquivalency.assets.hourDLL["$numberDecimal"]),
        };
        const infoSimulationProvider = {
            providerMoneyMX: parseFloat(payloadHrsEquivalency.providers.hourMX["$numberDecimal"]),
            providerMoneyDLL: parseFloat(payloadHrsEquivalency.providers.hourDLL["$numberDecimal"]),
        };

        const { tableEquivalency: tableAssetEquivalency } = getTableEquivalencySimulation(infoSimulationAssets);
        const { tableEquivalency: tableProviderEquivalency } = getTableEquivalencySimulation(infoSimulationProvider);
        dispatch(setTableEquivalencyAssets(tableAssetEquivalency));
        dispatch(setTableEquivalencyProvider(tableProviderEquivalency));

        //* checar assets, provedores y clickup
        const { status: stsSimulation, payload: payloadSimulation } = await getRequesAllDataInitSimulation(projectId);

        if (stsSimulation > 0) {
            dispatch(setErrorSimulation(true));
            dispatch(setLoadingSimulation(loadingsSimulation));
            MessageAnt(MessageType.error, "No se obtuvo correctamente las horas");
            return;
        }

        const { assets, teamArea, providers, clickuphrs } = payloadSimulation;
        const { areas } = teamArea;

        dispatch(setAreasTeam(areas));

        const { tableAssets } = getTableAssetsSimulation(assets, areas, {
            mxn: infoSimulationAssets.assetMoneyMX,
            usd: infoSimulationAssets.assetMoneyDLL,
        });
        dispatch(setAssetsTable(tableAssets));
        const { tableProvider, tableProviderSimulation } = getTableProvidersSimulation(providers, areas, {
            mxn: infoSimulationProvider.providerMoneyMX,
            usd: infoSimulationProvider.providerMoneyDLL,
        });
        dispatch(setProvidersCalculationTable(tableProviderSimulation));
        dispatch(setProvidersTable(tableProvider));

        //* clickup general
        const tableProviderGeneral = [].concat(tableProvider, tableProviderSimulation);
        dispatch(setProjectData(clickuphrs));
        dispatch(infoProjectGeneral(clickuphrs, tableAssets, tableProviderGeneral));

        //* generales
        dispatch(setIsExistHrsEquivalency(false));
        dispatch(setErrorSimulation(false));
        dispatch(setLoadingSimulation(loadingsSimulation));
    };
};

const getAllNotClickup = () => {
    return async (dispatch, getState) => {
        const {
            simulation: { loadings, projectId, areasTeam, projectData },
        } = getState();
        const { areas } = areasTeam;
        dispatch(setLoadingSimulation({ ...loadings, loadingTables: true }));

        const { status, payload } = await getRequesAllSimulationData(projectId);
        if (status > 0) {
            dispatch(setErrorSimulation(true));
            dispatch(setLoadingSimulation(loadingsSimulation));
            MessageAnt(MessageType.error, "No se obtuvo correctamente las horas");
            return;
        }
        const { equivalency, assets, providers } = payload;

        //* simulacion equivalencia
        const infoSimulationAssets = {
            assetMoneyMX: parseFloat(equivalency.assets.hourMX["$numberDecimal"]),
            assetMoneyDLL: parseFloat(equivalency.assets.hourDLL["$numberDecimal"]),
        };
        const infoSimulationProvider = {
            providerMoneyMX: parseFloat(equivalency.providers.hourMX["$numberDecimal"]),
            providerMoneyDLL: parseFloat(equivalency.providers.hourDLL["$numberDecimal"]),
        };

        const { tableEquivalency: tableAssetEquivalency } = getTableEquivalencySimulation(infoSimulationAssets);
        const { tableEquivalency: tableProviderEquivalency } = getTableEquivalencySimulation(infoSimulationProvider);
        dispatch(setTableEquivalencyAssets(tableAssetEquivalency));
        dispatch(setTableEquivalencyProvider(tableProviderEquivalency));

        const { tableAssets } = getTableAssetsSimulation(assets, areas, {
            mxn: infoSimulationAssets.assetMoneyMX,
            usd: infoSimulationAssets.assetMoneyDLL,
        });
        dispatch(setAssetsTable(tableAssets));

        const { tableProvider, tableProviderSimulation } = getTableProvidersSimulation(providers, areas, {
            mxn: infoSimulationProvider.providerMoneyMX,
            usd: infoSimulationProvider.providerMoneyMX,
        });
        dispatch(setProvidersCalculationTable(tableProviderSimulation));
        dispatch(setProvidersTable(tableProvider));

        //* clickup general
        const tableProviderGeneral = [].concat(tableProvider, tableProviderSimulation);
        dispatch(infoProjectGeneral(projectData, tableAssets, tableProviderGeneral));

        dispatch(setLoadingSimulation(loadingsSimulation));
    };
};

export const requestHrsEquivalency = (type = typeForm.create, form, updateProject = async () => { }) => {
    return async (dispatch, getState) => {
        const {
            simulation: { loadings, projectId },
        } = getState();
        dispatch(setLoadingSimulation({ ...loadings, buttonCreateEquivalency: true }));
        let status = 0;
        let msg = "";

        if (type === typeForm.create) {
            const { status: stsCreate } = await postRequestimulation(projectId, form);
            status = stsCreate;
            msg = "No se guardo los datos de simulación";
        }

        if (type === typeForm.edit) {
            const { status: stsEdit } = await putRequesSimulation(projectId, form);
            dispatch(modalActives());
            status = stsEdit;
            msg = "No se edito los datos de simulación";
        }

        if (status > 0) {
            dispatch(setLoadingSimulation(loadingsSimulation));
            MessageAnt(MessageType.error, msg);
            return;
        }

        if (type === typeForm.create) {
            dispatch(getAllSimulation(projectId));
        }

        if (type === typeForm.edit) {
            dispatch(getAllNotClickup());
        }

        await updateProject()
    };
};

export const modalActives = (type = modalsTypeSimulation.equivalency, active = false, typeFormModal = typeForm.create, formExtra = {}) => {
    return async (dispatch, getState) => {
        const {
            simulation: { modals, tableEquivalencyAssets, tableEquivalencyProviders },
        } = getState();
        //* desactivar
        if (!active) {
            const desActiveModal = Object.keys(modalsTypeSimulation).reduce((obj, key) => {
                obj[modalsTypeSimulation[key]] = false;
                return obj;
            }, {});
            dispatch(setModals({ ...modals, ...desActiveModal }));
            return;
        }

        let form = {};

        //* equivalency edit
        if (type === modalsTypeSimulation.equivalency) {
            tableEquivalencyAssets.forEach(({ key, hrs }) => {
                form = { ...form, [key]: hrs };
            });
            tableEquivalencyProviders.forEach(({ key, hrs }) => {
                form = { ...form, [key]: hrs };
            });
            dispatch(setFormEquivalecy(form));
        }

        //* assets edit and create
        if (type === modalsTypeSimulation.assets) {
            dispatch(setFormAssets(formInitAssetsSimulation));
        }

        //* provider edit and create
        if (type === modalsTypeSimulation.provider) {
            dispatch(setFormProviders(formInitProviderSimulation));
        }

        dispatch(setSelectTypeForm(typeFormModal));

        dispatch(setModals({ ...modals, [type]: active }));
    };
};

export const requetsAssetsSimulation = (form = {}, updateProjects = async () => { }) => {
    return async (dispatch, getState) => {
        const {
            simulation: { selectTypeForm, areasTeam, projectId, loadings, selectId },
        } = getState();
        dispatch(setLoadingSimulation({ ...loadings, buttonCreateAssestLoading: true }));
        const findAreaId = areasTeam.find((area) => trimSpaces(area.name) === trimSpaces(form.area));
        if (!findAreaId) {
            MessageAnt(MessageType.warning, "No se encontró area");
            dispatch(setLoadingSimulation(loadingsSimulation));
            return;
        }
        const { _id } = findAreaId;
        if (selectTypeForm === typeForm.create) {
            const formCreate = {
                ...form,
                areaId: _id,
                link: form.link === "" ? "-" : form.link,
            };
            delete formCreate.area;
            const { status: stsCreateAssets } = await postRequesAssetsSimulation(projectId, formCreate);
            if (stsCreateAssets > 0) {
                MessageAnt(MessageType.error, "No se creo el assest");
                dispatch(setLoadingSimulation(loadingsSimulation));
                return;
            }
        }

        //* Editar
        if (selectTypeForm === typeForm.edit) {
            const formEdit = {
                ...form,
                assetSimulationId: selectId,
                areaId: _id,
                link: form.link === "" ? "-" : form.link,
            };
            delete formEdit.area;
            const { status: stsEditAssets } = await putRequesAssetsSimulation(formEdit);
            if (stsEditAssets > 0) {
                MessageAnt(MessageType.error, "No se actualizo el assest");
                dispatch(setLoadingSimulation(loadingsSimulation));
                return;
            }
        }

        dispatch(setFormAssets(formInitAssetsSimulation));
        dispatch(modalActives());
        dispatch(getAllNotClickup());

        await updateProjects()
    };
};

export const requetsDeleteAssetsSimulation = (id, updateProject = async () => { }) => {
    return async (dispatch, getState) => {
        const { status: stsDeleteAssets } = await deleteRequesAssetsSimulation({
            data: {
                assetSimulationId: id,
            },
        });
        if (stsDeleteAssets > 0) {
            MessageAnt(MessageType.error, "No se elimino el assest");
            dispatch(setLoadingSimulation(loadingsSimulation));
            return;
        }

        dispatch(getAllNotClickup());
        await updateProject()  
    };
};

export const requetsProviderSimulation = (form = {}, updateProject = async () => { }) => {
    return async (dispatch, getState) => {
        const {
            simulation: { selectTypeForm, areasTeam, projectId, loadings, selectId },
        } = getState();
        dispatch(setLoadingSimulation({ ...loadings, buttonProviderLoading: true }));

        if (!form.area) {
            const formEdit = {
                ...form,
            };
            const { status: stsEditProvider } = await putRequesProviderSimulation(selectId, formEdit);
            if (stsEditProvider > 0) {
                MessageAnt(MessageType.error, "No se edito el proveedor");
                dispatch(setLoadingSimulation(loadingsSimulation));
                return;
            }
            dispatch(getAllNotClickup());
            return;
        }

        const findAreaId = areasTeam.find((area) => trimSpaces(area.name) === trimSpaces(form.area));
        if (!findAreaId) {
            MessageAnt(MessageType.warning, "No se encontró area _>");
            dispatch(setLoadingSimulation(loadingsSimulation));
            return;
        }
        const { _id } = findAreaId;

        let typeUrl = "A";

        if (selectTypeForm === typeForm.create) {
            const formCreate = {
                ...form,
                areaId: _id,
                link: form.link === "" ? "-" : form.link,
            };
            delete formCreate.area;
            if (form.price === undefined) {
                typeUrl = "B";
                formCreate.providerHours = 0;
            } else {
                formCreate.hourEquivalence = 0;
            }
            const { status: stsCreateProvider } = await postRequesProviderSimulation(projectId, formCreate, typeUrl);
            if (stsCreateProvider > 0) {
                MessageAnt(MessageType.error, "No se creo el proveedor");
                dispatch(setLoadingSimulation(loadingsSimulation));
                return;
            }
        }

        //* Editar
        if (selectTypeForm === typeForm.edit) {
            const formEdit = {
                ...form,
                areaId: _id,
                link: form.link === "" ? "-" : form.link,
            };
            delete formEdit.area;
            const { status: stsEditProvider } = await putRequesProviderSimulation(selectId, formEdit);
            if (stsEditProvider > 0) {
                MessageAnt(MessageType.error, "No se edito el proveedor");
                dispatch(setLoadingSimulation(loadingsSimulation));
                return;
            }
        }

        dispatch(setFormAssets(formInitAssetsSimulation));
        dispatch(modalActives());
        dispatch(getAllNotClickup());
        await updateProject()
    };
};

export const requetsDeleteProviderSimulation = (id, updateProject = async () => { }) => {
    return async (dispatch, getState) => {
        const { status: stsDeleteProvider } = await deleteRequesProviderSimulation(id);
        if (stsDeleteProvider > 0) {
            MessageAnt(MessageType.error, "No se elimino el proveedor");
            dispatch(setLoadingSimulation(loadingsSimulation));
            return;
        }

        dispatch(getAllNotClickup());
        await updateProject()
    };
};
